import React, { FunctionComponent, Ref } from 'react';
import cn from 'classnames/bind';
import Media from 'react-media';

import { Button } from '@/shared/components/Button/Button';
import PlayIcon from '@/shared/assets/MoviePlay';

import { ChannelCardWallpaper } from '../ChannelCardWallpaper/ChannelCardWallpaper';
import { ChannelWallpaperManager } from '../../lib/channelWallpaperManager';
import { ChannelWallpaperItem } from '../../lib/utils/getChannelsWallpapers';

import styles from './ChannelCardModal.module.css';

const cx = cn.bind(styles);

interface Props {
    currentChannelWallpaper: ChannelWallpaperItem;
    offerInfoRef: Ref<HTMLDivElement>;
    title: string;
    offerText?: string;
    buttonText: string;
    subscriptionName: string | undefined;
    isOfferAvailable: boolean;
    wallpapperChannelsManager: ChannelWallpaperManager;
    onBuyButtonClick?: () => void;
    isLoginwallEnabled?: boolean;
}

export const ChannelCardModalComponent: FunctionComponent<Props> = ({
    currentChannelWallpaper,
    title,
    offerText,
    buttonText,
    subscriptionName,
    offerInfoRef,
    isOfferAvailable,
    wallpapperChannelsManager,
    onBuyButtonClick,
    isLoginwallEnabled,
}) => (
    <div className={cx('content')} data-test-id="ChannelCardModal_content">
        <ChannelCardWallpaper
            className={cx('wallpaper')}
            currentChannelWallpaper={currentChannelWallpaper}
            wallpapperChannelsManager={wallpapperChannelsManager}
        />
        <div ref={offerInfoRef} className={cx('offer-details')}>
            {title && (
                <span className={cx('title')} data-test-id="ChannelCardModal_title">
                    {title}
                </span>
            )}
            {isOfferAvailable && (
                <>
                    <Media query="(min-width: 768px)">
                        {(match: boolean) => (
                            <Button
                                size={match ? 52 : 48}
                                variant={isLoginwallEnabled ? 'accent' : 'plus'}
                                startIcon={isLoginwallEnabled ? null : <PlayIcon fill="#fff" />}
                                onClick={onBuyButtonClick}
                                className={cx('watch-action')}
                                data-test-id="ChannelCardModal_offerButton"
                            >
                                {buttonText}
                            </Button>
                        )}
                    </Media>
                    {subscriptionName && !isLoginwallEnabled && (
                        <span className={cx('subscription-name')}>{subscriptionName}</span>
                    )}
                    {offerText && !isLoginwallEnabled && (
                        <span
                            className={cx('offer-text')}
                            data-test-id="ChannelCardModal_offerText"
                        >
                            {offerText}
                        </span>
                    )}
                </>
            )}
        </div>
    </div>
);
